export enum PartyTypeEnum {
    Contact = 'contactpersoon',
    Counterparty = 'tegenpartij',
    Witness = 'getuige',
    CoInsured = 'medeverzekerde',
    Driver = 'bestuurder',
    Other = 'anders',
}
